export const REDUCER_NAME = "competitionSeasons";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_COMPETITIONSEASONS = `${REDUCER_NAME}/SET_COMPETITIONSEASONS`;
export const RESET_COMPETITIONSEASONS = `${REDUCER_NAME}/RESET_COMPETITIONSEASONS`;
